import React from "react"
import { ReactNode } from "react"
import styled from "styled-components"
import { SimpleHeader, SIMPLE_HEADER_HEIGHT } from "src/components/SimpleHeader"
import { Sidebar, SIDEBAR_WIDTH } from "src/components/Sidebar"
import { Auth, useCurrentSmoother } from "src/features/auth"
import { useRouter } from "next/router"
import { useSidebarContext } from "src/store/SidebarContext"

type Props = {
  className?: string
  children?: ReactNode
}

const LayoutContent: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const router = useRouter()
  const { isAdmin, smoother } = useCurrentSmoother()
  const { isSidebarVisible } = useSidebarContext()

  return (
    <>
      <SimpleHeader
        pathname={router.pathname}
        replace={router.replace}
        currentSmoother={smoother}
      />
      <div className="layout-body">
        {isSidebarVisible && <Sidebar isAdmin={isAdmin} />}
        <main className="layout-main">{children}</main>
      </div>
    </>
  )
}

const Component: React.VFC<Props> = (props) => {
  return (
    <div className={props.className}>
      <Auth>
        <LayoutContent>{props.children}</LayoutContent>
      </Auth>
    </div>
  )
}

const StyledComponent = styled(Component)`
  position: relative;
  min-height: 100vh;
  background-color: #ffffff;

  .layout-body {
    display: flex;
    padding-top: ${SIMPLE_HEADER_HEIGHT}px;
    min-height: 100vh;
  }

  .layout-main {
    flex: 1;
    overflow-x: auto;
    padding: 16px;
  }

  .react-slidedown {
    height: 0;
    transition-property: none;
    transition-duration: 0.5s;
    transition-timing-function: ease-in-out;
  }

  .react-slidedown.transitioning {
    overflow-y: hidden;
  }

  .react-slidedown.closed {
    display: none;
  }
`

export const DefaultLayout = StyledComponent
